<template>
    <nav class="public-navbar navbar navbar-expand-xl navbar-light py-3">
        <div class="container">
            <router-link class="text-start navbar-brand" to="/" :aria-label="$t('navbar.home')">
                <img :src="locale === 'ro' ? '/img/identity/tgt_ro.png' : '/img/identity/tgt_com.png'" alt="Tapgiant" height="34">
            </router-link>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse text-center" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto mb-2 mb-xl-0 me-xl-2">
                    <li class="nav-item">
                        <router-link active-class="text-decoration-underline" class="nav-link text-gray-700 p-2 py-xl-3 fw-bold" :to="{ name: 'how_it_works' }">{{$t('navbar.how_it_works')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link active-class="text-decoration-underline" class="nav-link text-gray-700 p-2 py-xl-3 fw-bold" :to="{ name: 'pricing' }">{{$t('navbar.pricing')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link active-class="text-decoration-underline" class="nav-link text-gray-700 p-2 py-xl-3 fw-bold" :to="{ name: 'store_provisioning' }">{{$t('navbar.store_provisioning')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link active-class="text-decoration-underline" class="nav-link text-gray-700 p-2 py-xl-3 fw-bold" :to="{ name: 'contact' }">{{$t('navbar.contact')}}</router-link>
                    </li>
                    <li class="public-navbar__member-item nav-item d-xl-flex align-items-xl-center py-2 py-xl-0">
                        <a class="public-navbar__member-link btn btn-outline-brand py-2 px-3" :href="'https://store.' + TLD" :title="$t('navbar.order_management')">
                            {{$t('navbar.order_management')}}
                        </a>
                    </li>
                </ul>
                <div v-if="email && is_authorized" class="dropdown d-inline-block">
                    <button type="button" class="btn btn-brand bg-gradient text-white nav-item dropdown-toggle py-2 px-4" data-bs-toggle="dropdown" aria-expanded="false">
                        {{$t('navbar.account')}}
                    </button>
                    <ul class="dropdown-menu dropdown-menu-start dropdown-menu-xl-end">
                        <li>
                            <router-link to="/console/account" class="dropdown-item" type="button">
                                <BootstrapIcon class="align-middle d-inline-block me-3" color="text-teal-500" :name="'person-circle'" :size="18" />
                                <span class="align-middle d-inline-block">{{$t('navbar.settings')}}</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/console/store" class="dropdown-item" type="button">
                                <BootstrapIcon class="align-middle d-inline-block me-3" color="text-gray-600" :name="'gear'" :size="18" />
                                <span class="align-middle d-inline-block">{{$t('navbar.control_panel')}}</span>
                            </router-link>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                            <a @click="logout()" class="dropdown-item align-middle">
                                <BootstrapIcon class="align-middle d-inline-block me-3" color="fill-red-500 text-red-500" :name="'power'" :size="18" />
                                <span class="align-middle d-inline-block text-red-500">{{$t('navbar.logout')}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <template v-else>
                    <router-link class="btn btn-link text-gray-700 fw-bold nav-item py-2 px-3" to="/login">{{$t('navbar.login')}}</router-link>
                    <router-link class="btn btn-brand text-white nav-item py-2 px-4 mx-2" to="/login">{{$t('navbar.start_free')}}</router-link>
                </template>
            </div>
        </div>
    </nav>
</template>

<script>
import BootstrapIcon from '@/common/directive/BootstrapIcon'
import { TLD } from '@/common/constants.js'

export default {
    components: {
        BootstrapIcon
    },
    data: function () {
        return {
            TLD
        }
    },
    computed: {
        locale: function () {
            return this.$i18n.locale
        },
        email: function () {
            return this.$store.state.user.email
        },
        is_authorized: function () {
            return this.$store.state.is_authorized
        }
    },
    methods: {
        logout: async function () {
            await this.$store.dispatch('LOGOUT')
            this.$router.replace('/')
        }
    }
}
</script>
